export const titleTranslation = {
    en: "Contact",
    he: "צור קשר",
    ar: "للتواصل",
};

export const introTranslation = {
    en: "Have a project?<br />I'd <span class='color-red'>love</span> to help",
    he: "יש לך פרויקט?<br /> אני <span class='color-red'>אשמח</span> לעזור",
    ar: "لديك مشروع؟<br /> سأكون <span class='color-red'>مسروراً</span> بمساعدتك",
};

export const socialLinksTranslation = {
    en: "Let's Connect!",
    he: "בוא נתחבר!",
    ar: "لنتواصل!",
};

export const contactFormTranslation = {
    userName: {
        name: "sender",
        id: "name",
        icon: "person",
        input: "input",
        inputType: "text",
        label: {
            en: "Full name",
            he: "שם מלא",
            ar: "الاسم الكامل",
        },
    },
    userPhone: {
        name: "phone_number",
        id: "phone",
        icon: "call",
        input: "input",
        inputType: "text",
        label: {
            en: "Phone number",
            he: "מספר טלפון",
            ar: "رقم الهاتف",
        },
    },
    userEmail: {
        name: "email",
        id: "email",
        icon: "at",
        input: "input",
        inputType: "email",
        label: {
            en: "E-mail",
            he: "אימייל",
            ar: "البريد الإلكتروني",
        }
    },
    userMessage: {
        name: "message",
        id: "message",
        icon: "mail",
        input: "textarea",
        label: {
            en: "Message",
            he: "הודעה",
            ar: "الرسالة",
        },
    },
    submitBtn: {
        en: "Send",
        he: "שלח",
        ar: "أرسل",
    },
};


export const contactErrorTranslation = {
    headline: {
        en: "Dear Customer",
        he: "לקוח יקר",
        ar: "عزيزي الزبون"
    },
    content: {
        en: "You've already sent us a message recently, please give us time to response or try again later",
        he: "כבר שלחת לנו הודעה לאחרונה, אנא תן לנו זמן להגיב או נסה שוב מאוחר יותר",
        ar: "لقد أرسلت إلينا رسالة مؤخرًا، يرجى منحنا وقتًا للرد أو المحاولة مرة أخرى لاحقًا",
    }
}

export const contactSuccessTranslation = {
    headline: {
        en: "Dear Customer",
        he: "לקוח יקר",
        ar: "عزيزي الزبون"
    },
    content: {
        en: "Your message has landed safely in our inbox. We'll be soaring through it and getting back to you soon",
        he: "ההודעה שלך נחתה בשלום בתיבת הדואר הנכנס שלנו. אנחנו נמריא דרך זה ונחזור אליך בהקדם.",
        ar: "لقد وصلت رسالتك بأمان في صندوق الوارد لدينا. سنحلق من خلاله ونعود إليك قريبًا",
    }
}